// components
import { Box } from '@mui/material';

// styles
import { StyledTooltipListItem } from './FlexMatch.styles';

// types
import { GetToolbarActionsParams } from './FlexMatch.types';
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

export const renderTooltipItem = (
  label: React.ReactNode,
  content: React.ReactNode,
  index: number,
  last: boolean
) => (
  <StyledTooltipListItem key={index} divider={!last}>
    <Box>{label}</Box>
    <Box>{content}</Box>
  </StyledTooltipListItem>
);

export const getToolbarActions = (params: GetToolbarActionsParams) => {
  const {
    t,
    tHeader,
    filters,
    setNewRequestOpen,
    handleAcceptAllRequest,
    isAcceptingAll,
    rowSelectionMap,
    handleFilterClick,
    viewMode,
    setViewMode,
    VIEW_MODE_META
  } = params;

  const extraFiltersCount = filters
    ? Object.keys(filters).filter((k) => k !== 'startDate' && k !== 'endDate')
        .length
    : 0;

  return [
    {
      tooltipLabel: t('newFlexRequest'),
      id: 'flex-match-new-request',
      icon: 'plus' as IconType,
      onClick: () => setNewRequestOpen(true),
      rightDivider: true,
      actionDataTourId: 'flex-match-new-request',
      alignment: 'left' as const
    },
    {
      tooltipLabel: tHeader('bulkActions.accept'),
      id: 'flex-match-accept-all',
      icon: 'check-double' as IconType,
      onClick: handleAcceptAllRequest,
      actionDataTourId: 'flex-match-bulk-actions',
      disabled: isAcceptingAll || (rowSelectionMap?.size ?? 0) === 0,
      alignment: 'left' as const
    },
    {
      tooltipLabel: t('filter'),
      id: 'flex-match-filter',
      icon: 'sliders' as IconType,
      onClick: handleFilterClick,
      rightDivider: true,
      actionDataTourId: 'flex-match-filter',
      alignment: 'left' as const,
      pulsingBadge: {
        isActive: extraFiltersCount > 0,
        content: extraFiltersCount > 0 ? extraFiltersCount : undefined
      }
    },
    {
      tooltipLabel: 'View',
      id: 'flex-match-view-mode',
      icon: 'eye' as IconType,
      contextMenu: [
        {
          label: VIEW_MODE_META.compact.label,
          icon: VIEW_MODE_META.compact.icon as IconType,
          onClick: () => setViewMode('compact'),
          selected: viewMode === 'compact'
        },
        {
          label: VIEW_MODE_META.detailed.label,
          icon: VIEW_MODE_META.detailed.icon as IconType,
          onClick: () => setViewMode('detailed'),
          selected: viewMode === 'detailed'
        }
      ],
      actionDataTourId: 'flex-match-view-mode',
      alignment: 'right' as const
    }
  ];
};
